import { useContext } from "react";
import { StudioContext } from "./StudioContext";

export const useStudio = () => {
  const context = useContext(StudioContext);

  if (!context) {
    throw new Error("useStudio must be used within a StudioContext");
  }

  return context;
};
